import React, { useRef, useState, useCallback, useEffect, useMemo, memo } from 'react';
import PropTypes from 'prop-types';

import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';

import * as bannerUtils from '../../../banner/utils';
import { bannerLocalConstant } from '../../../banner/utils';
import useRedirect from '../../../customHooks/useRedirect';
import { getLocalStorage } from '../../../../common/common';
import { updateCurrentQueue } from '../../../../Store/actions';

// #region constants

// #endregion

// #region styled-components

// #endregion

// #region functions

// #endregion

// #region component
const propTypes = {};

const defaultProps = {};

/**
 *
 */

const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  // console.log('returning from previous' + ref.current);
  return ref.current;
};

const useCompare = (val) => {
  const prevVal = usePrevious(val);
  // console.log('return from useCompare' + prevVal !== val);
  return prevVal !== val;
};

let position = bannerLocalConstant.BANNER_POSITION_VIDEO;

const TARGET_TYPE_FLOATING = 'Floating';
const TARGET_TYPE_FILLER = 'Filler';
const TARGET_TYPE_FIXED = 'Fixed';
const _TARGET_BLANK = '_blank';

let progress_delay = 10;
let temp_creative_id = 0;

const PROGRESS_INTERVAL = 1000;
const DATA_DESIMAL_POINT = 2;
const timeFormat = 'YYYY-MM-DD HH:mm:ss';

const VIDEO_TYPE_ADS = 'ads';
const VIDEO_TYPE_MAIN = 'content';
const VideoAdsWorker = ({
  currentTime,
  duration,
  playing,
  isInFullScreen,
  page_id,
  page_name = ''
}) => {
  const _playing_item_ref = useRef([]);
  const _playing_index_ref = useRef(-1);

  let content_ads_data = useSelector((state) => state.banner.content_banner_data);
  let content_fetch_status = useSelector((state) => state.banner.content_data_get);
  let global_ads_data = useSelector((state) => state.banner.banner_data);
  let banner_exclution_list = useSelector((state) => state.banner.banner_exclution_list);
  let banner_settings_data = useSelector((state) => state.banner.banner_settings);
  let banner_queue_data = useSelector((state) => state.banner.current_banner_queue);

  const [ads_banner_main_data, set_ads_banner_main_data] = useState([]);
  const [content_id, set_content_id] = useState(page_id ? page_id : 0);

  const [videoControl, setVideoControl] = useState(false);
  const [videoTitle, setVideoTitle] = useState('');
  const [videoDeeplink, setVideoDeeplink] = useState('');
  const [adsIndex, setAdsIndex] = useState(-1);
  const [showSkipBtn, setShowSkipBtn] = useState(false);
  const [previous_video_time, set_previous_video_time] = useState(0);
  const [playingVideoType, setPlayingVideoType] = useState(VIDEO_TYPE_MAIN);
  const [isEligbleForAds, setIsEligbleForAds] = useState(true);
  const [isMAxViewOver, setIsMaxViewOver] = useState(false);
  const [lastAdsViewedTimestamp, setLastAdsViewedTimestamp] = useState('');
  const [videoAdsShowCount, setVideoAdsShowCount] = useState(0);
  const [banner_play_data, set_banner_play_data] = useState([]);
  const [banner_position, set_banner_position] = useState(position);
  const [separate_data, set_separate_data] = useState({});
  const [isSpqShown, setIsSpqShown] = useState(false);

  const [video_ads_setting, set_video_ads_setting] = useState('');
  const [banner_user, set_banner_user] = useState(getLocalStorage('user', '{}')?.user_master_id);

  const { redirectTo } = useRedirect();
  const dispatch = useDispatch();
  const hasLastTimestampChanged = useCompare(lastAdsViewedTimestamp);
  const { search } = useLocation();
  const { id } = queryString.parse(search);
  const videoDetailsParent = useRef();

  const setBannerSettings = (_banner_settings_data, _position) => {
    let temp_banner_settings_data = _banner_settings_data;

    let module_settings = filterJsonByPosition(temp_banner_settings_data, _position);
    console.group('banner settings' + _position);
    // console.log('module settings inside out:' + JSON.stringify(module_settings) + '::' + _position);
    module_settings?.length > 0 && set_video_ads_setting(module_settings[0]);
    console.groupEnd('banner settings' + _position);
  };

  const filterJsonByPosition = (data = [], matching_value = '') => {
    return data.filter((x) => {
      return x?.position?.toLowerCase() == matching_value?.toLowerCase() && x?.status === '3';
    });
  };

  useEffect(() => {
    //console.log('banner settings changed ' + banner_settings_data?.length);
    if (banner_settings_data?.length > 0) {
      setBannerSettings(banner_settings_data, position);
    }
  }, [banner_settings_data, position]);

  useEffect(() => {
    if (content_fetch_status && content_ads_data?.video_banner_data?.length > 0 && adsIndex <= 0) {
      //console.log('content fetched');
      setAdsIndex(0);
      set_ads_banner_main_data(content_ads_data?.video_banner_data);
      dispatch(
        updateCurrentQueue({
          ...banner_queue_data,
          video_banner_data: content_ads_data?.video_banner_data[0]
        })
      );
    }
  }, [ads_banner_main_data, adsIndex]);

  useEffect(() => {
    if (
      content_id &&
      content_id != 0 &&
      banner_exclution_list?.length > 0 &&
      bannerUtils._isContains(banner_exclution_list, 'type', page_name)
    ) {
      let exclutionList = bannerUtils.filterExclutionListByType(banner_exclution_list, page_name);

      console.group(`checking exclutionList`);
      //console.log(JSON.stringify(exclutionList));
      console.groupEnd(`checking exclutionList`);

      if (exclutionList?.length > 0) {
        //console.log('exclution length >0');
        let { ids } = exclutionList[0];

        //console.log('ids:::' + ids.split(','));
        let excludedIds = ids ? ids.split(',') : [];

        if (excludedIds.includes(content_id)) {
          //console.log('exclution id  avalable');
          setIsEligbleForAds(false);
        } else {
          //console.log('exclution id not available');
          setIsEligbleForAds(true);
        }
      } else {
        //console.log('exclution not length >0');
        setIsEligbleForAds(true);
      }
    } else {
      //console.log('exclution else');
      setIsEligbleForAds(true);
    }
    return () => {};
  }, [banner_exclution_list]);

  // global and content banner data observer effect
  useEffect(() => {
    bannerUtils.log('bannner global effect');
    if (
      content_id &&
      content_id != 0 &&
      content_fetch_status &&
      content_ads_data &&
      typeof content_ads_data == 'object'
    ) {
      switch (position) {
        case bannerLocalConstant.BANNER_POSITION_VIDEO:
          if (content_ads_data.video_banner_data) {
            set_banner_play_data([...new Set([...content_ads_data.video_banner_data])]);
          }
          break;
        default:
          bannerUtils.log('no banner data found ');
          break;
      }
      // break data_extract_condition;
    } else if (
      (!content_id || content_id == 0) &&
      !content_fetch_status &&
      !content_ads_data &&
      global_ads_data &&
      typeof global_ads_data == 'object'
    ) {
      ////console.log('--------------------global available ');
      switch (position) {
        case bannerLocalConstant.BANNER_POSITION_VIDEO:
          if (global_ads_data.video_banner_data) {
            set_banner_play_data([...new Set([...global_ads_data.video_banner_data])]);
          }
          break;
        default:
          bannerUtils.log('no banner data found ');
          break;
      }
    } else if (
      content_id &&
      content_id != 0 &&
      content_fetch_status &&
      !content_ads_data &&
      global_ads_data &&
      typeof global_ads_data == 'object'
    ) {
      // ////console.log('--------------------global available ');
      switch (position) {
        case bannerLocalConstant.BANNER_POSITION_VIDEO:
          if (global_ads_data.video_banner_data) {
            set_banner_play_data([...new Set([...global_ads_data.video_banner_data])]);
          }
          break;
        default:
          bannerUtils.log('no global banner data found ');
          break;
      }
    } else {
      // set_banner_setting("0x0")
      // ////console.log('--------------------global not available ');
    }
  }, [global_ads_data, content_ads_data, content_fetch_status]);

  // banner play data observer
  useEffect(() => {
    // ////console.log('banner play data ' + banner_play_data?.length);
    if (banner_play_data?.length > 0) {
      filterBannerData();
    }
  }, [banner_play_data]);

  useEffect(() => {
    //let time = lastAdsViewedTimestamp;
    if (lastAdsViewedTimestamp && video_ads_setting.time_difference_between_ads) {
      //  timeDiffFromLastVideoPlay = 0;
      let timeDiffFromLastVideoPlay = getTimeDifference(lastAdsViewedTimestamp);

      if (
        timeDiffFromLastVideoPlay >= video_ads_setting.time_difference_between_ads &&
        playingVideoType == VIDEO_TYPE_MAIN &&
        !isEligbleForAds &&
        !isMAxViewOver &&
        !hasLastTimestampChanged
      ) {
        setIsEligbleForAds(true);
      } else {
        console.log('::::::::::::::::::::::::::::::::::::::::::::else' + hasLastTimestampChanged);
        setIsEligbleForAds(false);
      }
    }
  }, [
    currentTime,
    lastAdsViewedTimestamp,
    hasLastTimestampChanged,
    isEligbleForAds,
    video_ads_setting,
    isMAxViewOver,
    playingVideoType
  ]);

  useEffect(() => {
    if (
      playingVideoType == VIDEO_TYPE_MAIN &&
      !isSpqShown &&
      isEligbleForAds &&
      currentTime >= 0 &&
      adsIndex >= 0 &&
      ads_banner_main_data?.length > 0 &&
      adsIndex < ads_banner_main_data?.length &&
      !isMAxViewOver &&
      !hasLastTimestampChanged &&
      video_ads_setting
    ) {
      let percentageViewed = '';
      percentageViewed = (currentTime * 100) / duration;
      let adsItem =
        adsIndex >= 0 && ads_banner_main_data?.length > 0 ? ads_banner_main_data[adsIndex] : {};

      adsHandler(currentTime, ads_banner_main_data, adsIndex);
    } else {
      return false;
    }
  }, [
    currentTime,
    ads_banner_main_data,
    adsIndex,
    playingVideoType,
    duration,
    isEligbleForAds,
    lastAdsViewedTimestamp,
    hasLastTimestampChanged,
    isMAxViewOver,
    video_ads_setting,
    isSpqShown
  ]);

  function filterBannerData() {
    // ////console.log('inside filtern json');
    if (!banner_position) {
      throw new Error(
        'Banner Item Must Have a valid position (eg: top,side-top,bottom,side-bottom)'
      );
    }
    if (!page_name) {
      throw new Error('Banner Item Must Have a valid page_name');
    }

    let temp_top_banner_data = banner_play_data; //bannerUtils.filterJsonByPosition(banner_play_data, banner_position);

    const temp_banner_data = {
      top_banner_floating_data: [],
      top_banner_filler_data: [],
      top_banner_fixed_data: []
    };

    if (temp_top_banner_data?.length > 0) {
      temp_banner_data.top_banner_floating_data = bannerUtils.filterJsonByTargetType(
        temp_top_banner_data,
        TARGET_TYPE_FLOATING
      );

      temp_banner_data.top_banner_filler_data = bannerUtils.filterJsonByTargetType(
        temp_top_banner_data,
        TARGET_TYPE_FILLER
      );

      if (content_id && content_id != 0) {
        temp_banner_data.top_banner_fixed_data = bannerUtils.filterJsonByTargetType(
          temp_top_banner_data,
          TARGET_TYPE_FIXED
        );
      }

      set_separate_data(temp_banner_data);
    } else {
      bannerUtils.log('no Priority /////////');
    }
    // ////console.log('inside filtern json out');
    setPriorityList(temp_banner_data);
  }

  const removeElemIfCriteriaMatched = (arr = []) => {
    const _index = arr.findIndex(({ max_view_per_session, bal_view_per_user_per_camp }) => {
      return max_view_per_session <= 0 || bal_view_per_user_per_camp <= 0;
    });

    //console.log(arr?.length + 'removedData::' + _index);
    if (_index >= 0) {
      arr.splice(_index, 1);
    }
    return arr;
  };

  function setPriorityList(params_separate_data) {
    let temp_top_banner_playing_index =
      _playing_index_ref.current >= 0 ? _playing_index_ref.current : -1;
    console.log('inside set priority' + temp_top_banner_playing_index);
    temp_creative_id = 0;
    let temp_banner_item = [];
    if (params_separate_data.top_banner_fixed_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(params_separate_data.top_banner_fixed_data);
    } else if (params_separate_data.top_banner_floating_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(
        params_separate_data.top_banner_floating_data
      );
    } else if (params_separate_data.top_banner_filler_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(params_separate_data.top_banner_filler_data);
    } else {
    }

    console.log('<before 0 >' + temp_banner_item?.length);
    if (temp_banner_item && temp_banner_item?.length > 0) {
      /** setting up banner play index start */
      if (temp_top_banner_playing_index == -1) {
        console.log('inside case 1 ');
        _playing_index_ref.current = 0;
        setAdsIndex(0);
      } else if (temp_banner_item.length - 1 == temp_top_banner_playing_index) {
        console.log('inside case 2 ');
        _playing_index_ref.current = 0;
        setAdsIndex(0);
      } else if (temp_banner_item.length == temp_top_banner_playing_index) {
        console.log('inside case 3 ');
        _playing_index_ref.current = 0;
        setAdsIndex(0);
      } else {
        let next_stack = '';
        next_stack = temp_top_banner_playing_index + 1;
        _playing_index_ref.current = temp_top_banner_playing_index + 1;
        console.log(_playing_index_ref.current + 'inside case else ' + next_stack);
        setAdsIndex(next_stack);
      }
      /** setting up banner play index end */

      let previous_item_length = temp_banner_item?.length ?? 0;
      let previous_banner_type = temp_banner_item[_playing_index_ref.current]?.target_type ?? '';
      if (
        temp_banner_item?.length > 0 &&
        temp_banner_item[_playing_index_ref.current]?.target_type != TARGET_TYPE_FILLER
      ) {
        let _temp_banner_item = removeElemIfCriteriaMatched(temp_banner_item);

        temp_banner_item = _temp_banner_item;
      }

      console.log(previous_item_length + '<after1>' + temp_banner_item?.length);

      if (
        previous_banner_type != TARGET_TYPE_FILLER &&
        previous_item_length > 0 &&
        temp_banner_item?.length <= 0
      ) {
        let _separate_data = params_separate_data;
        console.log('<recursion>');

        if (previous_banner_type == TARGET_TYPE_FIXED) {
          console.log('fixed ');
          _separate_data.top_banner_fixed_data = temp_banner_item;
        } else if (previous_banner_type == TARGET_TYPE_FLOATING) {
          console.log('floating ');
          _separate_data.top_banner_floating_data = temp_banner_item;
        } else if (previous_banner_type == TARGET_TYPE_FILLER) {
          console.log('filler ');
          _separate_data.top_banner_filler_data = temp_banner_item;
        }
        _playing_index_ref.current = -1;
        _playing_item_ref.current = [];
        setAdsIndex(-1);
        set_ads_banner_main_data([]);

        dispatch(
          updateCurrentQueue({
            ...banner_queue_data,
            video_banner_data: []
          })
        );

        set_separate_data(_separate_data);
        setPriorityList(_separate_data);
      } else {
        console.log(
          previous_item_length +
            '<seting up>' +
            temp_banner_item?.length +
            ':index:' +
            _playing_index_ref.current
        );
        set_ads_banner_main_data([]);

        _playing_item_ref.current = [];
        dispatch(
          updateCurrentQueue({
            ...banner_queue_data,
            video_banner_data: []
          })
        );

        if (temp_banner_item?.length > 0) {
          _playing_item_ref.current = temp_banner_item;

          console.groupEnd('final setup' + position);
          console.log(_playing_index_ref.current + 'setting to state' + temp_banner_item?.length);
          set_ads_banner_main_data(temp_banner_item);
          dispatch(
            updateCurrentQueue({
              ...banner_queue_data,
              video_banner_data: temp_banner_item[_playing_index_ref.current]
            })
          );
        } else {
          dispatch(
            updateCurrentQueue({
              ...banner_queue_data,
              video_banner_data: []
            })
          );
          setAdsIndex(-1);
          set_ads_banner_main_data([]);
        }
      }
    } else {
    }
    console.log('video ads player', _playing_item_ref.current, _playing_item_ref.current);
  }

  const onBannerChange = (action = 'change') => {
    console.log('banner changed');
    try {
      const temp_session_data = sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA)
        ? JSON.parse(sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA))
        : '';

      const temp_reporting_data = bannerUtils.getBannerReportFormat();
      temp_reporting_data.type = contentType;
      temp_reporting_data.type_id = content_id;
      temp_reporting_data.banner_user = banner_user;
      temp_reporting_data.timestamp_get =
        temp_session_data && temp_session_data.get_timestamp ? temp_session_data.get_timestamp : 0;
      temp_reporting_data.campaign_id = ads_banner_main_data[adsIndex]?.campaign_id ?? '';
      temp_reporting_data.creative_id = ads_banner_main_data[adsIndex]?.items[0].creative_id ?? '';
      temp_reporting_data.position = ads_banner_main_data[adsIndex]?.position ?? '';
      temp_reporting_data.os = platform_name;

      const tempCurrentTime = dayjs(new Date()).subtract(currentTime, 'second');
      temp_reporting_data.start_time = dayjs(tempCurrentTime).format(
        bannerLocalConstant.BANNER_DATE_FORMAT
      );
      temp_reporting_data.end_time = bannerUtils.getCurrentTime();
      temp_reporting_data.duration = currentTime;

      // video_duration = 0;
      if (
        temp_reporting_data &&
        temp_reporting_data?.campaign_id &&
        temp_reporting_data?.creative_id
      ) {
        console.log('update report data');
        dispatch(updateReportData(temp_reporting_data));
      }

      bannerUtils.log('end of func.......................' + JSON.stringify(temp_reporting_data));
    } catch (error) {
      //console.log('error in banner' + error);
    }
    if (separate_data.top_banner_fixed_data?.length > 0) {
      TARGET_TYPE_FIXED;
    } else if (separate_data.top_banner_floating_data?.length > 0) {
      calculateMaxViewPerSession(TARGET_TYPE_FLOATING);
    } else if (separate_data.top_banner_filler_data?.length > 0) {
      calculateMaxViewPerSession(TARGET_TYPE_FILLER);
    } else {
      bannerUtils.log('no top banner data found /////////' + JSON.stringify(separate_data));
    }
  };
  const calculateMaxViewPerSession = (type = '') => {
    let temp_banner_data = ads_banner_main_data;
    if (adsIndex >= 0 && temp_banner_data?.length > 0) {
      calculation_condition: if (temp_banner_data[adsIndex]?.target_type == TARGET_TYPE_FILLER) {
        //console.log('filler');
        break calculation_condition;
      } else if (
        temp_banner_data[adsIndex].max_view_per_session &&
        parseInt(temp_banner_data[adsIndex].max_view_per_session) > 0 &&
        temp_banner_data[adsIndex].view_per_day &&
        parseInt(temp_banner_data[adsIndex].view_per_day) > 0
      ) {
        //console.log('cal');
        temp_banner_data[adsIndex].total_view_done_per_day_campaign =
          parseInt(temp_banner_data[adsIndex].total_view_done_per_day_campaign) + 1;
        temp_banner_data[adsIndex].max_view_per_user_campaign =
          parseInt(temp_banner_data[adsIndex].max_view_per_user_campaign) + 1;
        temp_banner_data[adsIndex].view_per_day =
          parseInt(temp_banner_data[adsIndex].view_per_day) - 1;
        temp_banner_data[adsIndex].max_view_per_session =
          parseInt(temp_banner_data[adsIndex].max_view_per_session) - 1;

        //----added for optimization----//
        temp_banner_data[adsIndex].bal_view_per_user_per_camp =
          parseInt(temp_banner_data[adsIndex].bal_view_per_user_per_camp) - 1;
        //----optimization----//
      } else {
        console.log('removing');
        try {
          temp_banner_data.splice(adsIndex, 1);
        } catch (error) {
          console.log(error);
        }
      }

      //////console.log("before" + temp_banner_data.length)
      if (
        temp_banner_data?.length > 0 &&
        temp_banner_data[_playing_index_ref.current].target_type != TARGET_TYPE_FILLER
      ) {
        temp_banner_data = removeElemIfCriteriaMatched(temp_banner_data);
      }

      ////console.log("after" + temp_banner_data.length)

      let temp_separate_data = '';
      temp_separate_data = separate_data;

      switch (type) {
        case TARGET_TYPE_FIXED:
          temp_separate_data.top_banner_fixed_data =
            temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
          break;
        case TARGET_TYPE_FILLER:
          temp_separate_data.top_banner_filler_data =
            temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
          break;
        case TARGET_TYPE_FLOATING:
          temp_separate_data.top_banner_floating_data =
            temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
          break;
        default:
          bannerUtils.log('type null');
          break;
      }

      let temp_local_data = sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA);
      temp_local_data = temp_local_data ? JSON.parse(temp_local_data) : '';

      console.log('data sync with local');
      if (
        typeof temp_local_data == 'object' &&
        typeof temp_local_data.global_banner_data == 'object'
      ) {
        switch (position) {
          case bannerLocalConstant.BANNER_POSITION_VIDEO:
            temp_local_data.global_banner_data.video_banner_data = [
              ...temp_separate_data.top_banner_fixed_data,
              ...temp_separate_data.top_banner_floating_data,
              ...temp_separate_data.top_banner_filler_data
            ];
            break;
          default:
            break;
        }

        if (
          content_id &&
          content_id != 0 &&
          content_ads_data &&
          typeof content_ads_data == 'object'
        ) {
        } else {
          sessionStorage.setItem(
            bannerLocalConstant.GLOBAL_BANNER_DATA,
            JSON.stringify(temp_local_data)
          );
        }
      } else {
        bannerUtils.log('not set on local');
      }

      setPriorityList(temp_separate_data);
      set_separate_data(temp_separate_data);
    } else {
      bannerUtils.log('banner data----------------');
    }
    bannerUtils.log('exit done ');
  };

  function getTimeDifference(from) {
    let now = getCurrentTime(); //todays date
    if (now == from) {
      //console.log('two date cannot be same ');
      return 0;
    }

    //console.log(`xnow::${now} and from:${from}::`);
    let duration = dayjs(now).diff(dayjs(from), 'second');

    // console.group('get time difference');
    //console.log(`now::${now} and from:${from}::duration${duration}`);
    // console.groupEnd('get time difference');
    return duration;
  }

  const adsHandler = (currentTime, ads_data, adsIndex) => {
    if (currentTime <= 0) {
      return false;
    }
    let percentageViewed = '';
    percentageViewed = (currentTime * 100) / duration;
    let adsItem = adsIndex >= 0 && ads_data?.length > 0 ? ads_data[adsIndex] : {};
    // console.group('ads Handler');
    // console.log(
    //   `ads handler:${adsIndex}::${currentTime}::${ads_data?.length}::\n${JSON.stringify(adsItem)}`
    // );
    // console.groupEnd('ads Handler');
    // ads handler:1::2::false::7.567247::3::27.58413277744997::true   //   // adsItem?.visited === 'false' &&
    if (
      playingVideoType == VIDEO_TYPE_MAIN &&
      percentageViewed &&
      percentageViewed >= 0 &&
      adsItem?.ad_start_time &&
      adsItem?.ad_start_time >= 0 &&
      Math.ceil(percentageViewed) >= Math.ceil(adsItem?.ad_start_time)
    ) {
      let temp_data = ads_data;
      temp_data[adsIndex].visited = true;
      set_ads_banner_main_data(temp_data);
      dispatch(
        updateCurrentQueue({
          ...banner_queue_data,
          video_banner_data: temp_data[adsIndex]
        })
      );
      if (playingVideoType != VIDEO_TYPE_ADS) {
        set_previous_video_time(Math.round(currentTime) >= 0 ? Math.round(currentTime) : 0);
      }
      setPlayingVideoType(VIDEO_TYPE_ADS);
      setvideoUrl(adsItem?.items[0]?.file);
      console.group('skip btn logic');
      if (adsItem?.isSkipButton) {
        console.log(adsItem?.isSkipButton + 'ads item if' + adsItem?.ad_skip_time);
        if (adsItem?.ad_skip_time >= 0) {
          console.log('ads item timer' + adsItem?.ad_skip_time);
          // setTimeout(() => {
          //console.log('time out done' + adsItem?.ad_skip_time);
          setShowSkipBtn(true);
          // }, parseInt(adsItem?.ad_skip_time) * 1000);
        }
      } else {
        console.log('ads item else' + adsItem[adsIndex]);
      }
      console.groupEnd('skip btn logic');
    }
  };

  return <></>;
};
VideoAdsWorker.propTypes = propTypes;
VideoAdsWorker.defaultProps = defaultProps;
// #endregion

export default memo(VideoAdsWorker);
